import { render, staticRenderFns } from "./ComponentTabMain.vue?vue&type=template&id=1f7feadf&scoped=true&"
import script from "./ComponentTabMain.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ComponentTabMain.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ComponentTabMain.vue?vue&type=style&index=0&id=1f7feadf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7feadf",
  null
  
)

export default component.exports